// extracted by mini-css-extract-plugin
module.exports = {"mCard":"gf","image":"hf","imageNoBackground":"if"};